import { OrderInformationSkeleton } from '@app/components/orders/OrderInformation/OrderInformationSkeleton';
import { Skeleton } from '@app/components/various/Skeleton';

export const CheckoutSummarySkeleton = () => {
  return (
    <>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
        <Skeleton type="text" size="xlarge" itemClassName="max-w-36" />
        <div className="w-full max-w-40">
          <Skeleton type="button" size="large" />
        </div>
      </div>
      <OrderInformationSkeleton />
    </>
  );
};
